import { DateTime } from 'luxon';

class User {
  public readonly id: string;
  public readonly name: string;
  public readonly profileImageUrl: string | null;
  public readonly comment?: string | null;
  public readonly createdAt: DateTime;
  public readonly email?: string;

  constructor({
    id,
    name,
    profileImageUrl,
    comment,
    createdAt,
    email,
  }: {
    id: string;
    name: string;
    profileImageUrl: string | null;
    comment?: string | null;
    createdAt: DateTime;
    email?: string;
  }) {
    this.id = id;
    this.name = name;
    this.profileImageUrl = profileImageUrl;
    this.comment = comment;
    this.createdAt = createdAt;
    this.email = email;
  }

  public static fromJSON = (value: any) => {
    const { id, name, profileImageUrl, comment, createdAt: _createdAt, email } = Object.assign({}, value);
    const createdAt = DateTime.fromISO(_createdAt);

    if (typeof id !== 'string') throw new TypeError('.id must be a string');
    if (typeof name !== 'string') throw new TypeError('.name must be a string');
    if (profileImageUrl && typeof profileImageUrl !== 'string')
      throw new TypeError('.profileImageUrl must be a string');
    if (comment && typeof comment !== 'string') {
      throw new TypeError('.description must be a string');
    }
    if (email && typeof email !== 'string') {
      throw new TypeError('.email must be a string');
    }

    return new User({
      id,
      name,
      profileImageUrl,
      comment,
      createdAt,
      email,
    });
  };
  public toJSON(): Record<string, any> {
    return {
      ...new Object(this),
    };
  }
}

export default User;
